export default __webpack_public_path__ + "img/get-ready.12c78885.svg";